import { render, staticRenderFns } from "./DeleteStaffPopup.vue?vue&type=template&id=21c0e0ea&scoped=true&"
import script from "./DeleteStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteStaffPopup.vue?vue&type=style&index=0&id=21c0e0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0e0ea",
  null
  
)

export default component.exports